export default "__VITE_ASSET__yZCU0RBQ__"